// @ts-strict-ignore
import * as React from "react";
import type { ReactEventHandler } from "react";
import {
  StyledInput,
  StyledLabel,
  ErrorText,
  ClearButtonContainer
} from "./style";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  onClear: () => void;
  onChange: ReactEventHandler;
  id: string;
  error?: string;
  label: string;
  showInlineError?: boolean;
}

const ClearButton = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1L13 13"
        stroke="#6B6B77"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 13L13 1.00002"
        stroke="#6B6B77"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const Input = ({
  onClear,
  label,
  onChange,
  error,
  showInlineError = true,
  id,
  value,
  ...props
}: Props) => {
  return (
    <label htmlFor={id}>
      <div
        css={`
          position: relative;
        `}
      >
        <StyledLabel error={!!error}>{label}</StyledLabel>
        <StyledInput
          value={value}
          id={id}
          error={!!error}
          onChange={onChange}
          {...props}
        />
        {!!value && (
          <ClearButtonContainer onClick={onClear}>
            <ClearButton />
          </ClearButtonContainer>
        )}

        {!!error && showInlineError && <ErrorText color="">{error}</ErrorText>}
      </div>
    </label>
  );
};

export default Input;
